// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tip-icon-wrapper[data-v-43026e37] {\n  display: flex;\n  align-items: center;\n}\n.tip-icon-wrapper .icon[data-v-43026e37] {\n  font-size: 20px;\n  margin-left: 12px;\n}\n.tree-wrapper[data-v-43026e37] {\n  max-height: 300px;\n  overflow: auto;\n}\n", ""]);
// Exports
module.exports = exports;
